export default {
  title: "Депонирование",
  subtitle: "Публичный реестр записей о депонировании произведений и результатов интеллектуальной деятельности.",
  empty: "Публичный реестр пока пуст.",
  detail: "Депозит",
  industry: "Отрасль",
  status: "Статус",
  submitted: "Подано",
  certificate: "Сертификат",
  loadFailed: "Не удалось загрузить депозиты.",
  portal: {
    title: "Портал депонирования",
    pageTitle: "Кабинет депонирования",
    pageSubtitle: "Управляйте заявками, следите за модерацией и получайте свидетельства в одном месте.",
    overview: "Обзор",
    registry: "Публичный реестр",
    my: "Мои депонирования",
    apply: "Подать заявку",
    moderation: "Проверка заявок",
    navAria: "Навигация по кабинету депонирования",
    overviewTitle: "Обзор кабинета",
    overviewSubtitle: "Сводка по вашим заявкам и очереди модерации.",
    myHint: "Черновики, поданные заявки и выданные свидетельства",
    moderationHint: "Проверка заявок и выдача свидетельств",
    totalMy: "Всего: {{count}}",
    draftsCount: "Черновиков: {{count}}",
    moderationTotal: "В очереди: {{count}}",
    goToSection: "Перейти в раздел",
    statsLoading: "Загружаем сводку…",
    applyTitle: "Заявка на депонирование",
    titleField: "Название",
    industryField: "Отрасль",
    submit: "Создать и отправить",
    emptyMine: "Нет депозитов и черновиков.",
    emptyModeration: "Очередь модерации пуста.",
    drafts: "Черновики",
    deposits: "Заявки",
    approve: "Одобрить",
    reject: "Отклонить",
    revision: "На доработку",
    forbidden: "Недостаточно прав для модерации.",
    applySuccess: "Заявка отправлена",
    searchPlaceholder: "Поиск по названию",
    sortNewest: "Сначала новые",
    sortOldest: "Сначала старые",
    sortTitle: "По названию",
    filters: "Фильтры реестра",
    openRecord: "Открыть запись «{{title}}»",
    noTitle: "Без названия",
    statusUnknown: "Статус: {{status}}",
    subtitles: {
      registry: "Опубликованные записи о депонировании.",
      my: "Черновики, поданные заявки и выданные свидетельства.",
      apply: "Название и отрасль — остальное можно дополнить позже.",
      moderation: "Заявки авторов, ожидающие решения.",
    },
    columns: { title: "Название", industry: "Отрасль", status: "Статус", step: "Шаг", updated: "Изменён", submitted: "Подано", actions: "Решение" },
    draftStep: "Шаг {{step}} из 4",
    continueDraft: "Продолжить",
    rejectTitle: "Отклонить заявку",
    rejectMessage: "«{{title}}» не будет депонировано. Автор увидит отказ в кабинете.",
    statuses: {
      pending_moderation: "На модерации",
      team_review: "Проверка",
      confirmed: "Подтверждено",
      rejected: "Отклонено",
      needs_revision: "На доработке",
      withdrawn: "Отозвано",
    },
  },
}